<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="footer__logo">
        <EaimmsLogo />
      </div>
      <div class="footer__info">
        <p class="typo-ignore typo-small-title">
          &copy; {{ $t('general.footer', { year: currentYear }) }}
        </p>
        &nbsp;
        <router-link
          :to="{ name: 'support' }"
          class="anchor anchor--inverse typo-small-title"
        >
          {{ $t('support.support_centre') }}
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

import EaimmsLogo from '@/images/eaimms-logo.svg';

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.footer {
  background-color: map-get($background-color, dark);

  &__container {
    border-top: 1px solid map-get($background-color, lightest);
    padding: bu(4) bu(3);
    position: relative;
  }

  &__logo {
    display: flex;
    justify-content: center;
    margin-bottom: bu(5);

    @include breakpoint(medium) {
      margin-bottom: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &__info {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    min-height: bu(3.75);

    @include breakpoint(small) {
      flex-direction: column;
    }

    @include breakpoint(medium) {
      flex-direction: row;
    }

    p {
      color: map-get($foreground-color, darker);
    }
  }
}
</style>
